import { get } from 'lodash';
import {JOB_STATUSES} from 'manual/constants';
import { UNIT_TYPES } from 'constants/unitTypes';
import { convert, inferUnit } from 'util/unitConversion';
import { area } from 'geometry/geojson/area';

export const parseGeneratedZones = ( featureCollection ) => {
  const { features } = featureCollection;
  const zones = {};

  features.forEach((feature, index) => {
    const zoneId = `zone-${index}`;
    zones[zoneId] = {
      geoJson: {
        geometry: feature.geometry,
        type: feature.type,
        properties: feature.properties.zoneMetadata
      },
      meta: {
        area: convert({
          from: { q: area(feature.geometry), u: UNIT_TYPES.hectare},
          to: { u: inferUnit('area').unitKey},
          precision: 5
        }),
        geometry: feature.geometry,
        index,
        isDeadZone: false,
        zoneId
      }
    };
  });
  return zones;
};


export const parseJobStatusForSuccess = result => {
  return get(result, 'data.jobsDomain.job.status', null) === JOB_STATUSES.SUCCEEDED;
};

export const parseJobStatusForFailure = result => {
  return get(result, 'data.jobsDomain.job.status', null) === JOB_STATUSES.FAILED;
};
